import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';
import { CostAccessGate } from '~/features/cost-estimate/components/cost-access-gate';
import { costEstimateDetailSearchSchema } from '~/features/cost-estimate/utils/cost-approvals-search';

// Estimate details — the target of every Slack cost card's "Open estimate details"
// button. Not nested under /cost-approvals (trailing `_`): that page has no Outlet.
// Lives under `_tenant` like the list: Slack links carry no `?sub=`, so the reconcile
// guard just back-fills the viewer's active subsidiary and the page renders; the
// estimate itself is read by workflowId, which workflow-service lets approvers
// read for any subsidiary (non-approvers: their own subsidiary only, else 404).
// The page is cost amounts: `CostAccessGate` lets in lily.ai users and cost approvers (any
// domain) once the server has answered, so a Slack link works for every approver.
const CostEstimateDetailPage = lazy(
  () => import('~/features/cost-estimate/pages/cost-estimate-detail-page'),
);

export const Route = createFileRoute('/_authenticated/_tenant/cost-approvals_/$workflowId')({
  validateSearch: costEstimateDetailSearchSchema,
  component: RouteComponent,
});

/** Reads the workflow id (path) and the History row's estimate id (search) for the page. */
function RouteComponent() {
  const { workflowId } = Route.useParams();
  const { estimateId } = Route.useSearch();
  return (
    <CostAccessGate>
      <Suspense fallback={<PageSkeleton />}>
        <CostEstimateDetailPage workflowId={workflowId} openedEstimateId={estimateId} />
      </Suspense>
    </CostAccessGate>
  );
}
